import { runBootstrap, renderBootstrapError } from './bootstrap';

runBootstrap().catch(renderBootstrapError);
